import { LandingPageConfig } from 'src/generated/landing-page-config-schemas/v1/type';
import Logo from '../../../LayoutV2/header/logo';
import React, { useContext } from 'react';
import { AppBar, Box, Button, Toolbar, useTheme } from '@mui/material';
import { useRouter } from 'next/router';
import useAnalytics from 'src/analytics/useAnalytics';
import UserContext from 'src/context/user';

type Props = LandingPageConfig['data']['header'];

const Header: React.FC<Props> = ({ ctaButton }) => {
  const theme = useTheme();
  const router = useRouter();
  const { track } = useAnalytics();
  const userContext = useContext(UserContext);
  const isLoggedIn = !!userContext?.user;

  const handleMenuRedirect = () => {
    track('Landing Page CTA Clicked', { cta_location: 'nav-bar' });
    router.push({ pathname: '/menu', query: router.query });
  };

  // This header is based on the standard LayoutV2 header (../LayoutV2/header)
  // but adds a max-width container around the content and removes the default
  // text-transform styling on the buttons. Since these changes are specific
  // to the tenant landing page, the layout is duplicated here instead of
  // modifying the standard header with an additional prop.
  return (
    <header>
      <AppBar
        position="static"
        sx={{
          boxShadow: 'inset 0px -1px 0px ' + theme.palette.grey[300],
          backgroundColor: theme.palette.background.paper,
        }}
      >
        <Toolbar
          disableGutters
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            maxWidth: '1312px',
            width: '100%',
            margin: '0 auto',
            px: 2,
          }}
        >
          <Logo />
          <Box sx={{ display: 'flex', gap: { xs: 1, md: 2 } }}>
            {isLoggedIn ? (
              <Button
                href={'/dashboard'}
                variant={'outlined'}
                sx={{
                  textTransform: 'none',
                  px: { xs: 1, sm: 2 },
                }}
              >
                Go to Dashboard
              </Button>
            ) : (
              <Button
                href={'/login'}
                variant={'outlined'}
                sx={{
                  textTransform: 'none',
                  px: { xs: 1, sm: 2 },
                }}
              >
                Login
              </Button>
            )}
            <Button
              onClick={handleMenuRedirect}
              variant={'contained'}
              sx={{
                textTransform: 'none',
                px: { xs: 1, sm: 2 },
              }}
            >
              {ctaButton.label}
            </Button>
          </Box>
        </Toolbar>
      </AppBar>
    </header>
  );
};

export default Header;
